import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltersRoutingModule } from './filters-routing.module';
import { ImageUploadModule } from 'angular2-image-upload';
import { SnotifyModule } from 'ng-snotify';

import { QuillModule } from 'ngx-quill';
import { SharedModule } from '../shared/shared.module';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { DatePipe } from '@angular/common';
import { TypeComponent } from './type/create-type/type.component';
import { TypeListComponent } from './type/type-list/type-list.component';
import { TagComponent } from './tag/create-tag/tag.component';
import { TagListComponent } from './tag/tag-list/tag-list.component';
/**
 * Import specific languages to avoid importing everything
 * The following will lazy load highlight.js core script (~9.6KB) + the selected languages bundle (each lang. ~1kb)
 */
export function getHighlightLanguages() {
  return {
    typescript: () => import('highlight.js/lib/languages/typescript'),
    css: () => import('highlight.js/lib/languages/css'),
    xml: () => import('highlight.js/lib/languages/xml')
  };
}
@NgModule({
  declarations: [
    TypeComponent,
    TypeListComponent,
    TagComponent,
    TagListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FiltersRoutingModule,
    SharedModule,
    FormsModule,
    SnotifyModule,
    HighlightModule,
    ImageUploadModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ align: [] }]
        ]
      }
    }),
    SharedModule
  ],
  exports: [],
  providers: [
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        languages: getHighlightLanguages()
      }
    },
    DatePipe,
  ]
})
export class FiltersModule {}
